import CryptoJS from "crypto-js";
const secretPass = "XkhZG4fW2t2W";

const isEncryption = process.env.REACT_APP_ENCRYPTION_FLAG ? process.env.REACT_APP_ENCRYPTION_FLAG === 'true': true
export const EncryptFunction = (text) => {
    if(isEncryption){
        const encrypted = CryptoJS.AES.encrypt(text?.toString(), secretPass).toString();
        return encodeURIComponent(encrypted);
    } else {
        return text
    }
};

export const DecryptFunction = (text) => {
    if(isEncryption){
        let decrypted;
        try {
            decrypted = CryptoJS.AES.decrypt(decodeURIComponent(text), secretPass);
        } catch(e) {
            console.error(e); // logs URIError: URI malformed
        }
        return decrypted?.toString(CryptoJS.enc.Utf8);
    } else {
        return text;
    }

};
console.log(process.env.REACT_APP_AES_KEY, process.env.REACT_APP_AES_IV)

const key = CryptoJS.enc.Hex.parse(process.env.REACT_APP_AES_KEY);
const iv = CryptoJS.enc.Hex.parse(process.env.REACT_APP_AES_IV);

// Encrypt
export const EncryptSecretFunction = (text) => {
  const encrypted = CryptoJS.AES.encrypt(text, key, { iv: iv });
  return encrypted.toString(); // Base64 string
};

// Decrypt
export const DecryptSecretFunction = (cipherText) => {
  try {
    const decrypted = CryptoJS.AES.decrypt(cipherText, key, { iv: iv });
    return decrypted.toString(CryptoJS.enc.Utf8);
  } catch (e) {
    console.error("Decryption failed:", e);
    return "";
  }
};

export const EncryptObjectFunction = (object) => {
     if(isEncryption){
         const text = JSON.stringify(object);
         const encrypted = CryptoJS.AES.encrypt(text?.toString(), secretPass).toString();
         return encodeURIComponent(encrypted);
     } else {
        return encodeURIComponent(JSON.stringify(object));
     }
};

export const DecryptObjectFunction = (text) => {
     if(isEncryption){
            let decrypted;
    try {
        decrypted = CryptoJS.AES.decrypt(decodeURIComponent(text), secretPass);
        const decryptedText = decrypted.toString(CryptoJS.enc.Utf8);
        if (decryptedText) {
            return JSON.parse(decryptedText);
        } else {
            console.warn("Decryption returned empty or invalid text.");
            return null; 
        }
    } catch (e) {
        console.error("Error during decryption or JSON parsing:", e);
        return null; 
    }
     } else {
         return JSON.parse(text);;
     }
};

